export default __webpack_public_path__ + "static/media/B0004.c27da06a.png";